import React, { Component } from 'react';
import './BarraNavegacion.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars} from '@fortawesome/free-solid-svg-icons'
import { faBell, faEnvelope, faUserCircle} from '@fortawesome/free-regular-svg-icons'
import IconoNotificacion from '../Miscelanea/IconoNotificacion';

class BarraNavegacion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            abierto: false
        }
    }

    render() {
        return (
            <div className="barra-principal">
                <img className="logo-barra" src="imagenes/logo.png" />
                <div className="menu-usuario-barra">
                    <div className="btn-inicio-barra">Inicio</div>
                    <button className="btn-registro-barra">Soy un miembro</button>
                </div>
                <div className="menu-usuario-barra-responsivo" style={{color:"white"}}>
                    <IconoNotificacion icono={faBell} tamano="2x" numero={0}/>
                    <IconoNotificacion icono={faEnvelope} tamano="2x" numero={2}/>
                    <IconoNotificacion icono={faUserCircle} tamano="2x"/>                    
                </div>
                <div className="btn-sanguche-barra">
                    <FontAwesomeIcon icon={faBars} size="lg"/>
                </div>
            </div>
        )
    }

}

export default BarraNavegacion;